import { createRouter, createWebHashHistory } from 'vue-router'

const routes = [
  { path: '/', redirect: '/mainPage' },
  { path: '/test', component: () => import('./pages/test/index.vue') },
  { path: '/mainPage', component: () => import('./pages/mainPage/index.vue') },
  { path: '/recordList', component: () => import('./pages/recordList/index.vue') },
  { path: '/middleBack', component: () => import('./pages/middleBack/index.vue') },
  { path: '/bankPage', component: () => import('./pages/bankPage/index.vue') },
  { path: '/memberRecordList', component: () => import('./pages/memberRecordList/index.vue') },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes,
})

export default router
